module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--contentful group--sidebar"
  }, [_c('h1', {
    staticClass: "h1 article__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.article.name))]), _vm._v(" "), _c('h2', {
    staticClass: "h2 article__subtitle",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.article.sub))]), _vm._v(" "), _c('module-rich-text', {
    class: [_vm.article.sub ? "" : "mt20"],
    attrs: {
      "entry": _vm.article.richText
    }
  }), _vm._v(" "), (_vm.hasRelatedArticles) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.hasRelatedArticles) ? _c('span', {
    staticClass: "dt fw-bold c-accent h3 mb ",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Related Articles")]) : _vm._e(), _vm._v(" "), (_vm.hasRelatedArticles) ? _c('ul', {
    staticClass: "related-articles-list"
  }, [_c('li', {
    staticClass: "related-articles-list__item",
    on: {
      "click": function($event) {
        return _vm.navigateToArticle(_vm.article.related[0])
      }
    }
  }, [_c('a', {
    staticClass: "link tdn"
  }, [_c('h3', {
    staticClass: "p c-accent fw-bold mb0 related-articles-list__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.article.related[0] && _vm.article.related[0].name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "clamp",
      rawName: "v-clamp"
    }],
    staticClass: "related-articles-list__sub"
  }, [_vm._v(_vm._s(_vm.article.related[0].sub))])])]), _vm._v(" "), (_vm.article.related[1]) ? _c('li', {
    staticClass: "related-articles-list__item",
    on: {
      "click": function($event) {
        return _vm.navigateToArticle(_vm.article.related[1])
      }
    }
  }, [_c('a', {
    staticClass: "link tdn"
  }, [_c('h3', {
    staticClass: "p c-accent fw-bold mb0 related-articles-list__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.article.related[1] && _vm.article.related[1].name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "clamp",
      rawName: "v-clamp"
    }],
    staticClass: "related-articles-list__sub"
  }, [_vm._v(_vm._s(_vm.article.related[1].sub))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDisclaimer),
      expression: "showDisclaimer"
    }],
    attrs: {
      "modal": _vm.modalExternalData
    },
    on: {
      "close": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    nativeOn: {
      "click": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('module-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.goToUrl.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")])], 1)], 2), _vm._v(" "), (_vm.article.author && _vm.article.author.length) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.article.author) ? _c('p', {
    staticClass: "article__author fw-bold c-accent p",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_c('span', {
    staticClass: "dt fw-bold c-mid"
  }, [_vm._v("Author")]), _vm._v(" "), _c('span', {
    staticClass: "fw-medium"
  }, [_vm._v(_vm._s(_vm.article.author))])]) : _vm._e(), _vm._v(" "), (_vm.article.source && _vm.article.source.length) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.article.source) ? _c('p', {
    staticClass: "article__author fw-bold c-accent p",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_c('span', {
    staticClass: "dt fw-bold c-mid"
  }, [_vm._v("Article Source")]), _vm._v(" "), _c('span', {
    staticClass: "fw-medium"
  }, [_vm._v(_vm._s(_vm.article.source))])]) : _vm._e(), _vm._v(" "), (_vm.article.copyright && _vm.article.copyright.length) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.article.copyright) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.article.copyright.text))]) : _vm._e(), _vm._v(" "), (_vm.article.reviews || _vm.article.tags) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.article.reviews) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("Reviewed by " + _vm._s(_vm.article.reviews))]) : _vm._e(), _vm._v(" "), (_vm.article.tags) ? _c('ul', {
    staticClass: "list list--tags"
  }, _vm._l((_vm.article.tags), function(tag, index) {
    return _c('li', {
      key: index,
      staticClass: "list__item list__item--tag"
    }, [_vm._v("\n      " + _vm._s(tag) + "\n    ")])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c0a5104"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/contentful/Article.vue
// module id = 577
// module chunks = 0